import React from 'react';
import PropTypes from 'prop-types';
import { RichTextPropTypes } from '../../prop-types';
import { country } from '../../utils/current-site.js';
// Components
import { FormAssembly } from '../form';
import LinkHandler from '../link-handler';
import RichText from '../rich-text';
// Styles
import {
  StyledContainer,
  SignupFormWrapper,
  SignupFormIntroText,
  Header,
  BodyText,
  FormContainer,
  PrivacyLine,
} from './styles';

export const privacyPaths = {
  England: '/contact_us/privacy',
  Scotland: '/about_us/about_this_website/privacy_policy',
};

const ConsentNotice = ({ siteName }) => (
  <PrivacyLine>
    <LinkHandler link={{ path: privacyPaths[siteName] }}>
      Read our privacy policy
    </LinkHandler>{' '}
    for more details
  </PrivacyLine>
);

const consentReplacement = () => <ConsentNotice siteName={country} />;

const SignupForm = ({
  headerText,
  signupFormBodyText,
  signupFormAssembly,
  submitColor,
  removeMarginBottom,
}) => (
  <SignupFormWrapper $removeMarginBottom={removeMarginBottom}>
    <StyledContainer>
      <SignupFormIntroText>
        <Header>{headerText}</Header>
        <BodyText>
          <RichText richText={signupFormBodyText} />
        </BodyText>
      </SignupFormIntroText>
      <FormContainer>
        <FormAssembly
          contentfulData={{
            ...signupFormAssembly,
            submitColor,
            consentReplacement,
          }}
        />
      </FormContainer>
    </StyledContainer>
  </SignupFormWrapper>
);

ConsentNotice.propTypes = {
  siteName: PropTypes.string.isRequired,
};

SignupForm.propTypes = {
  headerText: PropTypes.string.isRequired,
  signupFormBodyText: RichTextPropTypes,
  signupFormAssembly: PropTypes.object,
  submitColor: PropTypes.string,
  removeMarginBottom: PropTypes.bool,
};

export default SignupForm;

export const SignupFormAssembly = ({ contentfulData }) => (
  <SignupForm
    headerText={contentfulData.headerText}
    signupFormBodyText={contentfulData.signupFormBodyText}
    signupFormAssembly={contentfulData.signupFormAssembly}
    submitColor={contentfulData.submitColor}
    removeMarginBottom={contentfulData.removeMarginBottom}
  />
);

SignupFormAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
